document.addEventListener('DOMContentLoaded', function() {
    const bookings = JSON.parse(localStorage.getItem('bookings') || '[]');
    const bookingsList = document.getElementById('bookingsList');
    
    if (bookings.length === 0) {
        bookingsList.innerHTML = '<p class="no-bookings">No bookings found</p>';
        return;
    }
    
    // Sort bookings by date (newest first)
    bookings.sort((a, b) => new Date(b.bookingDate) - new Date(a.bookingDate));
    
    bookings.forEach(booking => {
        const bookingCard = document.createElement('div');
        bookingCard.className = 'booking-card';
        bookingCard.innerHTML = `
            <div class="booking-header">
                <h3>Booking ID: ${booking.bookingId}</h3>
                <span class="booking-date">${new Date(booking.bookingDate).toLocaleDateString()}</span>
            </div>
            <div class="booking-details">
                <p><strong>Date:</strong> ${booking.appointmentDate}</p>
                <p><strong>Time:</strong> ${booking.appointmentTime} (${booking.appointmentTimezone})</p>
                <p><strong>Name:</strong> ${booking.firstName} ${booking.lastName}</p>
                <p><strong>Product:</strong> ${booking.productType}</p>
            </div>
        `;
        bookingsList.appendChild(bookingCard);
    });
}); 